import styled from "styled-components";

export const FeatureSection = styled.section`
  padding: 80px 20px;
  background-color: #151515;
  color: var(--lightText);
  position: relative;
  width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 56px 16px;
  }
`;

export const Container = styled.div`
  max-width: var(--maxWidth);
  margin: 0 auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
  display: grid;
  gap: 20px;
  justify-items: center;
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

export const HeaderTitle = styled.h2`
  font-size: clamp(2.5rem, 5vw, 3.8rem);
  font-weight: 800;
  background: linear-gradient(135deg, #ffffff 40%, #ff7a00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: 2px;
  line-height: 1.1;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.2rem;
    letter-spacing: 1px;
  }
`;

export const HeaderSubtitle = styled.h3`
  font-size: 1.15rem;
  color: #ffb347;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 10px 28px;
  border-radius: 999px;
  background: rgba(255, 122, 0, 0.08);
  box-shadow: inset 0 0 0 1px rgba(255, 122, 0, 0.2);
  display: inline-block;
  margin: 0;
  line-height: 1.4;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 8px 20px;
    letter-spacing: 1px;
  }
`;

export const HeaderDescription = styled.p`
  font-size: var(--fontSmall);
  color: #a1a1aa;
  max-width: 700px;
  margin: 0;
  line-height: 1.8;
  padding: 0 10px;
`;

export const FeatureImageContainer = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto 50px auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(255, 122, 0, 0.2);
  border: 2px solid rgba(255, 122, 0, 0.1);
  background: #111;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    object-position: center;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 25px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 36px;
  }
`;

export const CategoryCard = styled.div`
  background: rgba(255, 122, 0, 0.05);
  border: 1px solid rgba(255, 122, 0, 0.15);
  border-radius: 15px;
  padding: 25px;
  transition: all 0.3s ease;

  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
      background: rgba(255, 122, 0, 0.1);
      border-color: #ff7a00;
      box-shadow: 0 10px 30px rgba(255, 122, 0, 0.15);
    }
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
  }

  h3 {
    font-size: 1.2rem;
    color: #ff7a00;
    margin-bottom: 12px;
    position: relative;
    padding-left: 22px;
    line-height: 1.3;
  }

  h3::before {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 6px;
    height: 26px;
    border-radius: 4px;
    background: #fff;
  }

  p {
    font-size: 0.9rem;
    color: #d1d5db;
    line-height: 1.6;
  }
`;

export const UniverseBox = styled.div`
  position: relative;
  background: linear-gradient(135deg, rgba(255, 122, 0, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 30px;
  padding: 40px;
  margin-bottom: 50px;
  overflow: hidden;
  box-shadow: 0 35px 90px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(18px);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  min-height: 430px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 15% 20%, rgba(255, 122, 0, 0.2), transparent 18%),
      radial-gradient(circle at 85% 10%, rgba(255, 179, 71, 0.12), transparent 16%),
      radial-gradient(circle at 70% 90%, rgba(255, 255, 255, 0.08), transparent 12%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 30px;
    pointer-events: none;
  }

  @media (max-width: 920px) {
    grid-template-columns: 1fr;
    min-height: auto;
    padding: 28px;
  }
`;

export const UniverseLeft = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const UniverseBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 122, 0, 0.18);
  color: #ffb347;
  border: 1px solid rgba(255, 179, 71, 0.22);
  border-radius: 999px;
  padding: 10px 20px;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  width: fit-content;
`;

export const UniverseTitle = styled.h3`
  font-size: 2.7rem;
  line-height: 1.05;
  color: #fff;
  max-width: 540px;
  letter-spacing: 0.6px;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const UniverseText = styled.p`
  font-size: 1.05rem;
  color: #d8d8d8;
  max-width: 540px;
  line-height: 1.8;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const UniverseButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 190px;
  padding: 14px 26px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.95rem;
  text-decoration: none;
  transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
  box-shadow: ${({ secondary }) =>
    secondary
      ? '0 16px 40px rgba(255, 255, 255, 0.06)'
      : '0 16px 40px rgba(255, 122, 0, 0.25)'};
  background: ${({ secondary }) => (secondary ? 'rgba(255, 255, 255, 0.08)' : '#ff7a00')};
  color: ${({ secondary }) => (secondary ? '#fff' : '#0b0b0b')};
  border: ${({ secondary }) => (secondary ? '1px solid rgba(255, 255, 255, 0.12)' : 'none')};

  &:hover {
    transform: translateY(-3px);
    background: ${({ secondary }) => (secondary ? 'rgba(255, 255, 255, 0.14)' : '#ff922b')};
  }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const StatItem = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 18px 20px;
  text-align: center;
  color: #f3f3f3;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02);

  strong {
    display: block;
    font-size: 1.45rem;
    color: #ffb347;
    margin-bottom: 6px;
  }

  span {
    display: block;
    color: #c9c9c9;
    font-size: 0.95rem;
  }
`;

export const UniverseRight = styled.div`
  position: relative;
  z-index: 1;
  min-height: 320px;
`;

export const CardStack = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 340px;
`;

export const CardItem = styled.div`
  position: absolute;
  width: 220px;
  min-height: 140px;
  padding: 22px;
  border-radius: 24px;
  backdrop-filter: blur(12px);
  background: rgba(18, 18, 18, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 18px 40px rgba(255, 122, 0, 0.12);
  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
  cursor: default;

  strong {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 16px;
    background: rgba(255, 122, 0, 0.14);
    color: #ffb347;
    font-size: 1.2rem;
    margin-bottom: 14px;
  }

  h4 {
    font-size: 1.05rem;
    margin-bottom: 10px;
    color: #fff;
    position: relative;
    padding-left: 18px;
  }

  h4::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    width: 4px;
    height: 24px;
    border-radius: 4px;
    background: #ff7a00;
  }

  p {
    color: #c9c9c9;
    font-size: 0.92rem;
    line-height: 1.6;
  }

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 24px 55px rgba(255, 122, 0, 0.25);
    background: rgba(255, 255, 255, 0.06);
  }

  &.card-one {
    top: 0;
    left: 10%;
    transform: rotate(-4deg);
  }

  &.card-two {
    top: 16px;
    right: 0;
    transform: rotate(5deg);
  }

  &.card-three {
    top: 170px;
    left: 0;
    transform: rotate(2deg);
  }

  &.card-four {
    bottom: 0;
    right: 10%;
    transform: rotate(-3deg);
  }

  @media (max-width: 920px) {
    position: relative;
    width: 100%;
    transform: none !important;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    margin-bottom: 18px;
  }
`;

export const MarqueeWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: -32px;
  width: 100%;
  padding: 14px 30px;
  background: rgba(255, 255, 255, 0.03);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  border-radius: 0 0 30px 30px;

  @media (max-width: 920px) {
    position: relative;
    bottom: auto;
    border-radius: 20px;
    margin-top: 20px;
  }
`;

export const MarqueeTrack = styled.div`
  display: inline-flex;
  gap: 80px;
  min-width: 200%;
  animation: marquee 18s linear infinite;

  span {
    display: inline-flex;
    color: #ffb347;
    font-size: 0.95rem;
    letter-spacing: 0.06em;
    white-space: nowrap;
  }

  @keyframes marquee {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }
`;

export const LocationSection = styled.div`
  margin-top: 50px;
  text-align: center;

  h3 {
    font-size: 1.8rem;
    color: #fff;
    margin-bottom: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px;
    border-radius: 999px;
    background: rgba(255, 122, 0, 0.08);
  }
`;

export const LocationCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  padding: 24px;
  border-left: 4px solid #ff7a00;
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  text-align: left;

  h4 {
    color: #fff;
    font-size: 1.1rem;
    margin-bottom: 10px;
  }

  p {
    color: #a1a1aa;
    font-size: 0.9rem;
    margin-bottom: 8px;
  }

  strong {
    color: #ff7a00;
  }
`;

export const ShopButton = styled.a`
  display: inline-block;
  margin-top: 25px;
  padding: 12px 30px;
  background-color: #ff7a00;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  border-radius: 25px;
  text-transform: uppercase;
  box-shadow: 0 5px 15px rgba(255, 122, 0, 0.3);
  transition: background 0.3s ease;

  &:hover {
    background-color: #e65c00;
  }
`;
